import { AuthenticationInfo } from "types/AuthenticationInfo";
import { ActionType, getType } from "typesafe-actions";
import * as authenticationInfoActions from "./authenticationInfoActions";

export interface AuthenticationInfoState {
  loading?: boolean;
  data?: AuthenticationInfo[];
  error?: string;
}

export type AuthenticationInfoActions = ActionType<typeof authenticationInfoActions>;

export default function authenticationInfo(
  state: AuthenticationInfoState = {},
  action: AuthenticationInfoActions
) {
  switch (action.type) {
    case getType(authenticationInfoActions.load):
      return { ...state, loading: true };
    case getType(authenticationInfoActions.loadSuccess):
      return { ...state, loading: false, data: action.data, error: undefined };
    case getType(authenticationInfoActions.loadFail):
      return { ...state, loading: false, error: action.error };
    default:
      return state;
  }
}
